module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-5"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("TWO")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic",
    staticStyle: {
      "font-size": "1.78em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("A")]), _vm._v("drenaline rushed through Billie’s body and strangled her vocal cords. One minute she was setting her boundaries, letting Quinn know he didn’t need to feel obligated to her in any way. The next, she saw something barreling down the side of the mountain—straight at them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wasn’t sure what she expected Quinn to do, but throwing himself on top of her wouldn’t have been her first guess.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Quinn?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His warm breath tickled the side of her neck as he exhaled. Was he unconscious?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Quinn, are you okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He groaned. “What was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The litter, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m gonna be sore tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She realized they’d never been this physically close before. She’d practically lived at his lake house as his personal assistant, but they’d never touched except for a polite hug now and then.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His body, pressed against hers, felt solid and comforting. But she couldn’t afford to enjoy it too much.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you hurt?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He tipped his head back to look at her. He was so close she could see the gray specs in his blue eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It nailed me in the back, but I’m okay,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then would you mind...?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m heavy, right. Sorry, I’m probably crushing you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She didn’t correct him. It wasn’t his weight that bothered her as much as the ache of wanting something she could never have with this man.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Shifting off her, he stood and clenched his jaw as he pressed his hand against his back. He yanked the radio off his belt with his other hand.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Artie, what’s going on up there?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No response. Quinn glanced at Billie and she started to sit up again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey, hey,” Quinn said, putting out his hand to stop her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The litter’s gone and it’ll be dark in a few hours. I’m not spending the night here, Quinn. I can’t,” her voice cracked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You won’t. I’ll get you out of here.” He tried the radio again. “Artie?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A few tense seconds passed. “Sorry, Quinn. A new guy messed up.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then they shouldn’t have approved him for fieldwork.” Quinn sighed, shaking his head. “Have you got another litter, over?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sending one down now, over.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Roger that.” He glanced at Billie. “You’re going to be okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She closed her eyes and took a deep breath, relieved that she’d be lifted out of here instead of having to climb her way out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The search-and-rescue team would take her to the hospital where Quinn could absolve himself of his responsibilities. She knew he wasn’t here because he cared about her. He was here because Billie had become his pet project ever since he’d rescued her last year. He’d given her a job and a place to live, away from her local notoriety. He’d helped her find solid ground during a turbulent time in her life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d always be grateful to Quinn for that, but she had to make it clear that it was time for both of them to move on. Alone.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("Between the doctor’s examination, tests and giving her statement to the police about the man on the trail, six hours had passed and she still hadn’t had a chance to speak with Quinn alone. She wanted a private moment to set the boundary between them that she needed so desperately to define. Sure, he’d stuck close since the rescue, practically tailgating the ambulance to the hospital. He’d even tried pushing his way into the examining area but security managed to keep him out—at her request.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The sooner she distanced herself the better for both of them. But she wouldn’t humiliate him by having that conversation in front of strangers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was a necessary conversation. She was done being dependent on men who kept her at an emotional arm’s length. When she’d worked for him, Quinn had never missed an opportunity to remind her that he’d never be foolish enough to settle down with one woman.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then why did he keep showing up to save her? It was a coincidence, that’s all. He happened to be nearby and responded to the text alert.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stop thinking about him and focus on protecting yourself from Rick’s questionable business practices")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The man on the trail said Rick had worked for him. Doing what, some type of illegitimate activity? Her attacker accused Billie of going into the mountains to get something Rick had left behind worth a lot of money. But a sensible person wouldn’t hide something in the wilderness that could be destroyed by animals or weather.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The first thing she’d do after being released from the hospital would be to dig into Rick’s accounts. She’d abandoned her life after the accident because her insides had been so tangled in grief and regret, confusion and shame. Yet maybe a part of her was afraid to find out how far he had fallen.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She couldn’t do it any longer, especially since Rick’s business seemed to be putting her life at risk. Maybe she should leave Echo Mountain and conduct her investigation from a safe location in a different part of the country.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which meant finding a new job and making new friends, again. She sighed at the thought. She’d grown close to Bree, her boss’s sister and was finally feeling a part of the community and Echo Mountain Church. She didn’t want to think about moving again, although it could be the best option to remain safe.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Another option would be hiring a private investigator to dig into her husband’s accounts. If only she had the budget to afford one. Knowing what Rick was involved in could help Billie anticipate what was coming next and protect herself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The things you didn’t see coming were the most dangerous of all, things like Rick’s sudden personality change and questionable behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And Billie’s imprudent attraction to Quinn Donovan.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d been so relieved earlier today when she’d regained consciousness and seen Quinn staring down at her with worry in his eyes. She’d almost thought she was dreaming.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was not only relieved but also surprised. After she’d left Waverly Harbor, she never thought she’d see him again. Oh, he’d texted her a few times to make sure she was okay and had settled comfortably into her new life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d purposely kept her responses to his text messages polite but short and didn’t dare ask about his life. She didn’t want to know about his latest conquests, either in business or in the romance department.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A doctor in his mid-fifties with a gentle smile stepped into the examining area. “I’m Dr. Green. So, Wilhelma, are you on any medications or have you had any medical issues we should know about?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Please, call me Billie. No, no medications. I’m pretty healthy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And extremely lucky. You don’t seem to have sustained any serious injuries from the fall, but you do have bruised ribs, a sprained wrist and slight concussion.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Great, then you’re releasing me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’d prefer you stay overnight for observation. Your injuries have the potential for complications.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’d rather not. I have to—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’ll stay,” Quinn said, stepping around the corner into the examining area.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re not supposed to be here,” she snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The doctor glanced from Quinn to Billie. “Do I need to call security?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Billie crossed her arms over her chest and stared straight ahead. “No, it’s fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn extended his hand to the doctor. “Quinn Donovan. I’m with search and rescue. I helped retrieve Billie. Believe it or not, we’re friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The doctor glanced at Billie for confirmation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s true,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fine, well, they’ll come to move you to a room shortly,” the doctor said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do I really need to stay?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We need to keep an eye on swelling of the tissue, both in the lungs and brain, which could lead to more serious problems. Twenty-four hours to be safe.” Dr. Green nodded at Billie and left.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn stepped closer to the bed. “What’s the rush to get out of here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t like hospitals.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s more than that. Are you worried the guy from the trail is going to track you down? Because I won’t let that happen. I’m staying with you until you’re released.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s not necessary,” she said a little too sharply. “I’m not worrying about him, but I want to get out and start investigating what he said about Rick.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Investigating?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes, I need to figure out what Rick was into and why that man approached me on the trail.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I won’t allow it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Excuse me?” She half chuckled, wincing at the pain in her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s too dangerous.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s more dangerous if I do nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He leaned closer. “You don’t know what your husband was into. If you go digging into his business you’ll risk stirring up all sorts of trouble. You need to hire someone to do that for you, like a retired cop or a P.I.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t have the budget to—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll take care of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Absolutely not.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Billie—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not happening, Quinn. I won’t let you keep paying for things and taking care of me. I’m not a charity case and I resent being treated like one.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He jerked back as if she’d physically slapped him. She regretted the words, but they had to be said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m just trying to help,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You have. You’ve rescued me twice now. You’ve done more than enough. So please, go back to Waverly Harbor and leave me to manage my own life.”")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("Quinn didn’t care how much she protested, he wasn’t abandoning her, not until he knew she was truly safe. With a nod, he stepped into the hallway to give her space. He wouldn’t go far. She was fighting him with what little strength she had left and he didn’t want to upset her further.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But it was his duty to make sure she was okay. He’d assigned himself her protector after the first rescue for many reasons, the least of which being a request made by her dying husband: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Take care of Billie")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She deserves so much better")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No one knew about the dying man’s plea. Quinn didn’t even tell his own brother, Alex.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn would never forget the look in Billie’s brown eyes when she was told her husband had died. It wasn’t simply grief, it was complete and utter confusion. She’d obviously loved her husband and had been devastated by the loss.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After she came to work for Quinn and he got to know her better, he suspected something else, as well: regret. What he never figured out was if she regretted not being able to prevent her husband from spiraling into depression, or if she regretted marrying Rick Bronson in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Wishful thinking,” he muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It would make things so much easier if Quinn thought she’d wanted out of her marriage long before her husband died. Easier as in easier to pursue something more than friendship with Billie? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("That’s not easy. That’s insanity")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d made himself a promise never to go there with her, no matter how much his heart ached to have this special woman in his life. He simply didn’t deserve that kind of goodness, and she surely deserved better than a blackguard like Quinn.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Quinn?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn spotted his friend Aiden with his sister, Bree, heading in his direction. The tall, sandy-haired Aiden had become a good friend after they’d met on a search-and-rescue mission a few years ago. They’d bonded over their military service and love of hiking.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey, man, thanks for the call,” Quinn said as they shook hands. He never would have made it to Billie as quickly as he had if Aiden hadn’t called him. “Hi, Bree.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, Quinn, I’m so sorry. I got here as soon as I could.” She hugged him and Quinn glanced at his friend, questioning the emotional moment. Aiden shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How is Billie?” Aiden asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Banged up and cranky.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Billie, cranky?” Bree said, breaking the hug. “She must be hurting.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s putting on a good front, playing tough. But I sense she’s in a dark place.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And probably not only because of the fall,” Bree said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn studied her for a second, trying to figure out the meaning of her words.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’ve become friends,” Bree explained. “So I know a lot about her past, her marriage, stuff like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn wondered what “stuff” she knew about him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m so glad she activated the locator beacon and I got the emergency text,” Bree said. “She almost didn’t get the device, but I insisted.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn studied the twenty-seven-year-old search-and-rescue K9 team member. “Did you know she was going into the mountains by herself?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I did,” Bree said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why did you let her go alone?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s an experienced hiker,” Bree offered. “She knew what she was doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s not the point,” Quinn said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Billie is a grown woman. She’s not your little sister,” Bree said. “She’s extremely capable. She’s joined the SAR team and last month helped locate an Alzheimer’s patient who went missing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I didn’t know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She said you two hadn’t spoken in months. Anyway, she needed to go into the mountains for—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Closure, I get it,” he said, a little impatient.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Really, Quinn? Because I doubt you’ve ever sought closure for any of your brief relationships.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Bree,” Aiden warned.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her sharp words stung, but were not untrue.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m going to see Billie.” Bree brushed past the men and went into the E.R. examining area.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry, man, she can be snappy when she’s worried about a friend,” Aiden said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s okay, I probably deserved it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A few SAR members have been texting me about Billie, wanting to know if they can visit, bring flowers or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe when we get her home. Right now she needs peace and quiet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So, what happened? She’s a solid hiker.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn looked at Aiden. “She was assaulted.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn led Aiden to a visitor waiting area where they could speak privately. “Some guy on the trail threatened her. In an effort to get away it seems she fell off the trail.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She must have been terrified,” Aiden said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn’s gut clenched at the thought. “She’s not safe, not until we find out what her husband was into.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My cousin Tyler is a sheriff’s deputy. Want me to call him?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, Officer Vanguard already took her statement, but thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you staying with her?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn glanced down the hall toward the examining area. “Yes, even if I have to camp outside her hospital room.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You should ask to stay in her room tonight,” Aiden suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’d never allow it.” Quinn glanced at his friend. “I think it’s a pride thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, someone’s got to stay with her. Maybe Bree can stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No. I don’t want to put your sister in danger.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You think it’s that bad?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I won’t know what to think until I have more information. I need to get my clothes and laptop from the car. Can you hang out here for a few minutes and keep watch?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure. Go ahead, I’ll check in on Billie.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Aiden walked away. Quinn didn’t move for a few seconds. Even in a hospital full of doctors and nurses Quinn worried about Billie’s safety.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Now he was overreacting. Her attacker wouldn’t wander into a hospital to do her harm. She could identify him since she’d seen his face.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which only put her in more danger.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn headed to his car, focusing on the next three steps to achieve his goal. His organized mind had served him well, both in business and the military. He’d created the term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the next three")]), _vm._v(" to help his staff stay focused on the prioritized projects of the day.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In staff meetings he’d remind everyone about the importance of focus, yet today his focus had been blown to bits the second he saw Billie’s still body lying on the plateau below the trail.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jogging to his car, he reminded himself that Aiden was a capable man and between him and hospital security, no harm would come to Billie in the next ten minutes, the time it would take Quinn to change clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn had been very appreciative when Aiden offered Billie a job at Echo Mountain Resort months ago. Aiden said the favor was the least he could do considering Quinn designated the barn on the resort property as Search and Rescue headquarters for folks in their part of the county.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Even though Quinn owned the resort, he rarely meddled in Aiden’s management of the business. Sure he’d hoped Aiden would hire Billie. She needed to get away from Quinn and their dysfunctional relationship to start a new life, which she had as a hostess for the resort’s four-star restaurant. Quinn knew firsthand what a gracious hostess Billie could be since she’d planned plenty of dinners for Quinn and his business associates.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But those weren’t the only people he’d entertained at his lake house, and whenever he’d bring a woman to his place, Billie would serve a four-course, delicious meal. She’d smile and explain what ingredients were in the dishes she was about to serve, a smile that never seemed to reach her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Every time he brought home a date he sensed he was breaking Billie’s heart, even though he’d been clear that he and Billie could never be more than friends.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Quinn got his duffel out of the trunk and slammed it shut. He’d never meant to hurt her. Subconsciously he’d brought dates to the lake house so Billie would see what a jerk he was and keep her emotional distance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Instead she’d always looked at him with those compassionate eyes that saw straight through to his soul.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The next three things,” he reminded himself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d change clothes, contact his P.I. friend, Cody, about digging into Rick Bronson’s accounts and find a quiet spot to do some work close to Billie’s room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Because there was no way he’d let anyone hurt her again.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_vm._v("Spending the night in a hospital was dreary to say the least. It was nearly midnight and Billie lay wide awake, alone and disappointed: in Rick for making bad choices, in herself for not admitting the truth sooner about their failed marriage and...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was disappointed in Quinn.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There, she admitted that she’d secretly hoped he would have stayed close to keep an eye on her even though she’d demanded he leave.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Talk about mixed messages,” she whispered to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A young, blond nurse breezed into her room. “Hi, Billie, I’m nurse Beth. Sorry I’m running late for the eleven-o’clock vitals check.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No problem. My dance class doesn’t start for another hour,” she joked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Nurse Beth smiled. “How’s the pain on a scale of one to ten?” She took Billie’s pulse.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“About a four. I’m basically sore all over.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are your ribs worse than they were this afternoon?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not really.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good.” Nurse Beth took Billie’s temperature. “A-okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A male orderly in his mid-twenties with coal-black hair brought a wheelchair into the room. “Doctor wants another CT scan.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I didn’t see that order,” Nurse Beth said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The orderly handed her a piece of paper.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Huh, okay.” She looked at Billie. “Let me help you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Nurse Beth helped Billie slide out of bed. A little light-headed, Billie plopped quickly down into the wheelchair.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Take good care of her,” Nurse Beth said, hooking the IV bag to the wheelchair.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Will do.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The orderly pushed her out of the room and down the hall to the elevator. Although she’d been unable to sleep in her hospital bed, she felt drowsy from the meds they’d given her to manage the pain.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So, head injury, huh?” the orderly said, pressing the down button on the elevator.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And ribs and wrist. I decided to tumble down a mountainside for fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Whoa.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So, what’s your name?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Dylan.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m Billie.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nice name.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wheeled her into the elevator and the doors closed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Needless to say, I won’t be hiking for a while,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I used to love to hike.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Used to?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No time. I work at the hospital, plus go to community college and help out with the family business.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Which is...?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Restaurant.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What kind?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The elevator doors opened to the imaging department.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s called Healthy Eats. Sustainable living, organic ingredients, stuff like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, I heard about that opening up. Interesting concept.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, Mom had some health issues a few years ago so she and Dad changed our entire menu to be more health oriented.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So no cheeseburgers, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure, but we use grass-fed beef,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wheeled her into the imaging room for the CT scan and looked around. “Huh, the tech was supposed to be waiting for us. You okay here for a second? I’ll go find him.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He locked the wheels and went in search of the technician. She studied the CT machine, which looked like a large doughnut. That thought made her tummy grumble and she realized she hadn’t eaten anything substantial since breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey!” a male voice shouted.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A crash echoed in the hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She heard grunting and a squeak, like rubber soles kicking against vinyl flooring.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The hair bristled at the back of her neck.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It couldn’t be what it sounded like. No, low blood sugar was sending her imagination into overdrive. Dylan would be back shortly with the tech and everything would be fine.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her gaze darted to the wall phone. If she’d learned anything from being married to Rick, it was to listen to her gut.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Billie grabbed her IV bag off the hook and shuffled to the wall, grabbed the phone—")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A pop resounded from the hallway, then silence. She frantically pressed buttons, trying to focus, trying to press the right button to call security, the operator, someone who could help her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Suddenly the lights went out, plunging her into complete darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-3"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec569c14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 84
// module chunks = 0